<script setup>

import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import EmailConteudo from "./EmailConteudo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "criandoEmail",
    "controlesDesativados",
    "pedidoDeCompra"
]);

const emits = defineEmits([
    "update:criandoEmail",
    "update:controlesDesativados"
]);

//==================================================================//
//===================== Altera Criando Pedido ======================//
//==================================================================//

let conteudoEmailPadrao = `Prezados,\nSegue em anexo nosso Pedido de Compra, para suas providencias, favor confirmar o recebimento deste Pedido de Compra.\nO prazo para análise deste pedido de é de 02 dias úteis. Após este prazo, o mesmo será considerado como aceito e não mais será realizado qualquer tipo de modificação.\nAtenciosamente.`;

const email = ref({
    destinatarioNome: "",
    destinatarioEmail: "",
    comCopia: [],
    comCopiaOculta: [],
    assunto:"",
    conteudo: conteudoEmailPadrao,
    anexos: []
});

//==================================================================//
//===================== Altera Criando Pedido ======================//
//==================================================================//

const alteraCriandoEmail = (update) =>{

    emits('update:criandoEmail',update);

};

//==================================================================//
//================== Altera Controles Desativados ==================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//========================= Altera Email ===========================//
//==================================================================//

const alteraEmail = (update) =>{

    email.value = {
        ...email.value,
        ...update
    }
}

//==================================================================//
//========================= Altera Email ===========================//
//==================================================================//

const preencheComEmailPadrao = () =>{

    alteraEmail({
        destinatarioNome: props?.pedidoDeCompra?.fornecedorVendedor?.nome,
        destinatarioEmail: props?.pedidoDeCompra?.fornecedorVendedor?.email,
        comCopia: [props?.colaboradorStore?.colaborador?.email],
        comCopiaOculta: [],
        assunto: `Pedido de Compra N° ${props?.pedidoDeCompra?.codigo}`,
        conteudo: conteudoEmailPadrao,
        anexos: []
    });

}

//==================================================================//
//============================= Watch ==============================//
//==================================================================//

watch(()=> props.criandoEmail, () => {

    preencheComEmailPadrao();

});

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.criandoEmail"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card
                class="c-modal"
                :class="{ 'c-modal--disabled': props.controlesDesativados }"
            >

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :controlesDesativados="props.controlesDesativados"
                    :pedidoDeCompra="props.pedidoDeCompra"
                    :email="email"
                    :criandoEmail="props.criandoEmail"
                    @update:criandoEmail="alteraCriandoEmail"
                    @update:controlesDesativados="alteraControlesDesativados"
                >
                </BarraNavegacao>

                <EmailConteudo
                    :pedidoDeCompra="pedidoDeCompra"
                    :email="email"
                    :controlesDesativados="controlesDesativados"
                    @update:email="alteraEmail"
                ></EmailConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

.c-modal--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>

